<template>
    <div>
        <div class="group-buying-brief">
            <div class="brief-price">
                <div class="price-top">
                    <span class="tip">¥</span>
                    <span class="num">{{supportGroupBuying ? groupStartPrice : startPrice}}</span>
                    <span class="qi" v-if="multiPackage || !supportGroupBuying">起</span>
                </div>
                <div class="price-bottom" v-if="supportGroupBuying">
                    <span class="single-price">单买价 ¥<span>{{startPrice}}</span></span>
                    <div class="saled-num" v-if="count.saleCount > 0">
                        <span>已拼{{saleCountShow}}件</span>
                    </div>
                </div>
                <div class="price-bottom" v-else>
                    <span v-if="count.travelCount > 0">累计销量 <em>{{count.travelCount}}</em></span>
                    <span v-if="count.travelMonthlyCount > 0">月销 <em>{{count.travelMonthlyCount}}</em></span>
                </div>
            </div>
            <div class="brief-countdown">
                <div class="countdown-top">
                    <span>距离结束还剩</span>
                </div>
                <div class="countdown-bottom">
                    <div class="day-num">
                        <span>{{formatRemainTime.day}}</span>
                    </div>
                    <div class="day-desc">
                        <span>天</span>
                    </div>
                    <div class="bkb">
                        <span>{{formatRemainTime.hour}}</span>
                    </div>
                    <div class="punc">
                        <span>：</span>
                    </div>
                    <div class="bkb">
                        <span>{{formatRemainTime.minute}}</span>
                    </div>
                    <div class="punc">
                        <span>：</span>
                    </div>
                    <div class="bkb">
                        <span>{{formatRemainTime.second}}</span>
                    </div>
                    <div class="punc">
                        <span>：</span>
                    </div>
                    <div class="bkb cr">
                        <span>{{formatRemainTime.tenthOfSecond}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="brief-title">
            <span class="group-num" v-if="supportGroupBuying">{{groupActivity.joinPersonNum}}人团</span>
            <span>{{briefTitle}}</span>
            <span class="no-refund" v-if="canRefund === 0">【不可退】</span>
            <p class="isNew" v-if="supportGroupBuying && groupActivity.userLimit">【邀新团】参团用户需为途牛新注册会员，开团无限制</p>
        </div>
    </div>
</template>

<script>
    import formatTime from './formatTime';
    import { mapGetters } from 'vuex';

    export default {
        name: 'groupBuyingBrief',
        props: {
            //产品名称
            briefTitle: {
                type: String,
                default: ''
            },
            count: {
                type: Object,
                default: () => ({})
            },
            groupActivity: {
                type: Object,
                default: () => ({})
            },
            supportGroupBuying: {
                type: Boolean,
                default: false
            },
            startPrice: {
                type: Number,
                default: 0
            },
            saleRemainingTime: {
                type: Number,
                default: 0
            },
            canRefund: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                interval: null,
                formatRemainTime: {
                    day: '0',
                    hour: '00',
                    minute: '00',
                    second: '00',
                    tenthOfSecond: '0'
                }
            }
        },

        mounted() {
            this.startCountDown();
        },

        beforeDestroy() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        },


        computed: {
            ...mapGetters('derivativePackage', [
                'multiPackage',
                'groupStartPrice'
            ]),
            saleCountShow() {
                if (this.count.saleCount > 10000) {
                    return (this.count.saleCount / 10000).toFixed(1) + 'w'
                } else {
                    return this.count.saleCount
                }
            }
        },

        methods: {
            startCountDown() {
                let remainingTime;
                if (this.supportGroupBuying) {
                    if (this.saleRemainingTime) {
                        remainingTime = Math.min(this.groupActivity.remainingTime, this.saleRemainingTime);
                    } else {
                        remainingTime = this.groupActivity.remainingTime;
                    }
                } else {
                    remainingTime = this.saleRemainingTime;
                }
                if (this.interval) {
                    clearInterval(this.interval);
                }
                // let self = this;
                // function countDown() {
                //   if (remainingTime > 0) {
                //     self.formatRemainTime = formatTime.formatTime(remainingTime, true);
                //     // self.setData({formatRemainTime: formatTime.formatTime(remainingTime, true)})
                //     remainingTime -= 0.1;
                //     setTimeout(countDown, 100);
                //   }
                // }
                // countDown();
                this.interval = setInterval(() => {
                    if (remainingTime >= 0) {
                        this.formatRemainTime = formatTime.formatTime(remainingTime, true);
                        // this.setData({[`${this.$prefix}formatRemainTime`]: formatTime.formatTime(remainingTime, true)})
                    } else {
                        clearInterval(this.interval);
                    }
                    remainingTime -= 0.1;
                }, 100)
            }
        }
    }

</script>

<style lang="scss">
    .group-buying-brief {
        height: 54px;
        display: flex;
        background-size: 100% 100%;
        background-image: url(https://m4.tuniucdn.com/fb2/t1/G5/M00/65/B1/Cii-slzOecSIVO1XAAAhwZyC4CoAAVjAQP_makAACHZ623.png);

        .brief-price {
            flex: 202;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            color: #FFF;

            .price-top {
                font-family: DINAlternate-Bold;
                margin-left: 17px;

                .tip {
                    font-size: 20px;
                    line-height: 20px;
                }

                .num {
                    font-size: 32px;
                    line-height: 32px;
                }

                .qi {
                    font-family: PingFangSC-Light;
                    font-size: 15px;
                }
            }

            .price-bottom {
                font-family: PingFangSC-Semibold;
                font-size: 11px;
                display: flex;
                align-items: center;
                line-height: 14px;
                margin-left: 17px;

                .single-price {
                    text-decoration: line-through;
                    span {
                        font-family: DINAlternate-Bold;
                    }
                }

                .saled-num {
                    box-sizing: border-box;
                    height: 16px;
                    padding: 0 7px;
                    border: 0.8px solid #FFF;
                    border-radius: 8px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-left: 5px;
                }

                &>span:not(:first-child) {
                    margin-left: 5px;
                }
            }
        }

        .brief-countdown {
            box-sizing: border-box;
            flex: 173;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: center;
            font-size: 12px;
            color: #912804;
            line-height: 14px;

            .countdown-top {
                font-family: PingFang-SC-Regular;
                margin-bottom: 3px;
                margin-right: 18px;
            }

            .countdown-bottom {
                font-family: PingFang-SC-Medium;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-right: 18px;

                .day-num {
                    height: 18px;
                    display: flex;
                    align-items: flex-end;
                    margin-right: 0.4px;
                    margin-bottom: 1px;
                    font-family: HelveticaNeue-Medium;
                }

                .day-desc {
                    height: 18px;
                    width: 14px;
                    display: flex;
                    align-items: flex-end;
                    margin-bottom: 1px;
                    margin-right: 4px;
                }

                .bkb {
                    font-family: HelveticaNeue-Medium;
                    background: #912804;;
                    height: 18px;
                    width: 20px;
                    border-radius: 6px;
                    color: #FFF;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .cr {
                    color: #FFF;
                }

                .punc {
                    width: 7px;
                    height: 14px;
                    margin-left: 2px;
                    margin-right: 1px;
                    display: flex;
                    align-items: center;
                }
            }
        }
    }

    .brief-title {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #373737;
        padding: 9px 19px;
        line-height: 26px;
        background: #FFF;

        .group-num {
            height: 16px;
            width: 36px;
            background: #FF6436;
            border-radius: 8px;
            font-family: PingFangSC-Semibold;
            font-size: 11px;
            color: #FFF;
            line-height: 16px;
            display: inline-block;
            margin-right: 5px;
            text-align: center;
            position: relative;
            bottom: 2px;
            vertical-align: middle;
        }

        .no-refund {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #FF6436;
        }
        .isNew {
            font-family: PingFangSC-Medium !important;
            font-size: 12px !important;
            color: #FF6436 !important;
            background: #F2F2F2;
            border-radius: 10.5px;
            vertical-align:middle
        }
    }

    .no-price {
        color: rgba(32, 48, 64, 0.75);
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    }

</style>



// WEBPACK FOOTER //
// groupBuyingBrief.vue